// src/modules/app-views/products/pages/Document/decorators/request.js
// *******************************************************************************
// REQUEST DECORATOR
// Transforms data before sending to the server
// *******************************************************************************

// Transforms form data before sending to the server
const decorateRequest = ctx => {
  const { data, allValues } = ctx;

  if (!data) return data;

  // Clone data to avoid mutations
  const transformed = { ...data };

  // Remove cascader temp field (not a real data field)
  delete transformed._pendingLocationCascader;

  // ───────────────────────────────────────────────────────────────────────────
  // ATTACHMENTS TRANSFORMATION
  // Transform attachment objects (avatar, logo, cover, etc.) back to their format
  // Add _id from original data to identify which attachment to update
  // ───────────────────────────────────────────────────────────────────────────
  const attachmentTypes = [
    'avatar',
    'logo',
    'cover',
    'gallery',
    'document',
    'contract',
    'qrcode',
    'signature',
    'other',
  ];

  attachmentTypes.forEach(attachType => {
    if (data[attachType] && typeof data[attachType] === 'object') {
      // Get original attachment from attachments array (has _id, etc)
      const originalAttachment = allValues?.attachments?.find(
        a => a.attachmentType === attachType
      );

      // Ensure _id is included in the attachment object for edition
      // Also transform 'id' to 'attachmentId' if needed (AI-created products use 'id')
      const attachObj = { ...data[attachType] };
      if (attachObj.id && !attachObj.attachmentId) {
        attachObj.attachmentId = attachObj.id;
        delete attachObj.id;
      }

      transformed[attachType] = {
        ...attachObj,
        _id: originalAttachment?._id,
      };
    }
  });

  // ───────────────────────────────────────────────────────────────────────────
  // ATTACHMENTS ARRAY TRANSFORMATION
  // Transform attachments array: 'id' -> 'attachmentId' (backend expects attachmentId)
  // This handles products created by AI that have 'id' instead of 'attachmentId'
  // ───────────────────────────────────────────────────────────────────────────
  if (Array.isArray(transformed.attachments)) {
    transformed.attachments = transformed.attachments.map(att => {
      if (att && att.id && !att.attachmentId) {
        const { id, ...rest } = att;
        return { ...rest, attachmentId: id };
      }
      return att;
    });
  }

  // ───────────────────────────────────────────────────────────────────────────
  // COST SUMMARY CLEANUP
  // Remove virtual fields from cost summary card (not persisted directly)
  // These are display-only fields managed by SuppliersTab
  // ───────────────────────────────────────────────────────────────────────────
  delete transformed.stockValue;
  delete transformed.stockQty;
  delete transformed._displayPrice;

  // Never send suppliers via form save — managed by addToSet/removeFromSet
  delete transformed.suppliers;

  // Remove virtual/computed fields that leak from hydration or CardHeader
  delete transformed.stockValue;
  delete transformed.stockQty;
  delete transformed._displayPrice;
  delete transformed.currentPrice;
  delete transformed.stockStatus;
  delete transformed.hasFiscalData;
  delete transformed.profitMargin;

  return transformed;
};

export default decorateRequest;
